import { type FC, type SVGProps, HTMLProps } from 'react'

import Button from '@/components/common/Button'
import SourceFile from '@/components/common/SourceFile'
import useTranslation from '@/hooks/useTranslation'
import { twMerge } from '@/utils/tailwind'

interface WithConfirmationProps {
  file: File;
  targetFormat: string;
  onConvert: (file: File, format: string) => Promise<void>;
  showOcrButton?: boolean;
  onConvertOcr?: () => void;
  className?: HTMLProps<HTMLDivElement>['className'];
}

export type WithConfirmationReturnType = ReturnType<typeof withConfirmation>

export default function withConfirmation<P = {}>(
  ImageComponent: FC<SVGProps<SVGSVGElement>>
): FC<P & WithConfirmationProps> {
  return ({ file, targetFormat, onConvert, showOcrButton = false, onConvertOcr, className }) => {
    const { t } = useTranslation()

    return (
      <div className={twMerge('tw-flex tw-flex-col tw-items-center', className)}>
        <ImageComponent className='tw-mb-4' />

        <div className='tw-flex tw-flex-col md:tw-flex-row tw-w-full md:tw-w-auto tw-gap-4 md:tw-gap-8 tw-mb-4'>
          <Button className='tw-text-xl md:tw-text-lg md:tw-px-26 tw-px-4 tw-py-2'
                  onClick={() => onConvert(file, targetFormat)}
                  gtag={{ name: 'button-convert' }}>
            {t('pdfextra_convert_tool.confirmation.convert_button')}
          </Button>
          {showOcrButton &&
            <Button appearance='outlined'
                    className="tw-text-xl md:tw-text-lg md:tw-px-16 tw-px-4 tw-py-2"
                    onClick={onConvertOcr}
                    gtag={{ name: 'button-convert-ocr' }}>
              {t('pdfextra_convert_tool.confirmation.convert_ocr_button')}
            </Button>
          }
        </div>

        <SourceFile file={file} />
      </div>
    )
  }
}
